import { render, staticRenderFns } from "./PopupAddInterest.vue?vue&type=template&id=23b276ce&scoped=true&"
import script from "./PopupAddInterest.vue?vue&type=script&lang=js&"
export * from "./PopupAddInterest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b276ce",
  null
  
)

export default component.exports